const tableTitleManagementService = {
  title: 'Services',
  placeholder: 'Search',
  addRowLabel: 'new service',
  excelGenerateToaster: 'Exporting 2000 first matches'
};

export default tableTitleManagementService;
